<div [ngClass]="{ 'has-video': hasVideo }" #newsContainer class="news-container" data-test-id="news-container">
  <!-- news image -->
  @if (hasImage && !hasVideo && !hasGallery) {
    <div
      [ngStyle]="{
        width: imageSize.width + 'px',
        height: imageSize.height + 'px',
        'background-image': 'url(' + bannerImage + ')',
      }"
      class="news-image flex"
      data-test-id="news-container-news-image"
    ></div>
  }

  <!-- news video -->
  @if (hasVideo && !hasGallery) {
    <div
      [ngStyle]="{
        width: videoPlayerConfig.containerWidth + 'px',
        height: videoPlayerConfig.containerHeight + 'px',
      }"
      class="news-video iframe-video"
      data-test-id="news-container-news-video"
    >
      @if (!showVideo) {
        <div
          [ngStyle]="{
            width: videoPlayerConfig.containerWidth + 'px',
            height: videoPlayerConfig.containerHeight + 'px',
            'background-image': 'url(' + bannerImage + ')',
          }"
          (click)="show()"
          class="video-plug"
          data-test-id="news-container-news-video-plug"
        ></div>
      }
      @if (showVideo) {
        <my7n-video-player
          [articleId]="news?.Id"
          [config]="videoPlayerConfig"
          [module]="LogVideoModules.News"
          [title]="news?.Title"
          [videoUrl]="news?.VideoUrl"
          data-test-id="news-container-news-video-player"
        ></my7n-video-player>
      }
    </div>
  }

  <!-- gallery -->
  @if (hasGallery) {
      <div class="news-gallery" data-test-id="news-gallery">
        <sharepoint-gallery
          [config]="galleryConfig"
          [newsId]="newsId"
          [galleryName]="galleryName"
          [limit]="listGalleryLimit"
        ></sharepoint-gallery>
      </div>
  }

  <div class="news-content flex flex-col">
    <!-- news title -->
    @if (news.Title) {
      <h3 class="news-title" data-test-id="news-container-news-title">
        <a [routerLink]="detailsUrl">{{ news.Title | truncate: titleLimit : true }}</a>
      </h3>
    }

    <!-- news description with more link -->
    <div class="news-description" data-test-id="news-container-news-description">
      @if (news.Description) {
        <p
          [innerHTML]="news.Description | removeByTags: ['table', 'a'] | truncate: descriptionLimit : true"
          class="news-description-text"
          data-test-id="news-container-news-description-text"
        ></p>
      }
      <a [routerLink]="detailsUrl" color="accent" data-test-id="news-description-read-more" mat-button type="button">
        Read more
      </a>
    </div>
    <hr />
    <!-- news footer -->
    <div class="news-footer flex flex-row flex-between-center" data-test-id="news-container-news-footer">
      <div
        class="footer-author-container flex max-sm:flex-col sm:gap-24 max-sm:flex-start-start sm:max-md:flex-between-center md:flex-start-center"
      >
        <!-- news author info -->
        <div class="news-author-info flex flex-start-center md:gap-12">
          <div class="news-author-info-avatar max-md:hidden" data-test-id="news-container-news-author-info-avatar">
            <avatar [avatarUrl]="news.AuthorAvatar" [title]="news.AuthorName"></avatar>
          </div>
          <div
            class="news-author-info-name-posted flex flex-col flex-[1_1_0%]"
            data-test-id="news-container-news-author-info-name-posted"
          >
            <span class="news-author-info-name">{{ news.AuthorName }}</span>
            <span class="news-author-info-job-title">{{ news.AuthorJobTitle }}</span>
          </div>
        </div>

        <!-- news dates -->
        <div class="news-dates flex flex-start-center gap-12" data-test-id="news-container-news-dates">
          <mat-icon class="max-md:hidden" svgIcon="calendar_big"></mat-icon>
          <span class="news-author-info-posted">{{ news.Published | defaultDate: 'minute' : true }}</span>
        </div>
      </div>
      <reactions [contentId]="news.Id" [contentType]="contentType" data-test-id="reactions"></reactions>
    </div>
  </div>
</div>
